import { useAppointmentCancelNotificationQuery } from "../../../../../../../api/appointments/useAppointmentCancelNotificationQuery";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useCancelNotification() {
  const { appointment } = useContext();

  const { data } = useAppointmentCancelNotificationQuery(
    { appointmentId: appointment.id },
    {
      onError: () => {
        uiNotification.error(
          "Unable to load cancel notification details. Try again later.",
        );
      },
    },
  );

  return data;
}
